// extracted by mini-css-extract-plugin
export default {"root":"SliderCard-module__root___1rBKc"};